module.exports = __webpack_public_path__ + "img/icon_trial_fail_1.4cc58ce9.png";